import { createSlice } from "@reduxjs/toolkit";

// api client
import apiClient from "./apiClient.js";
import { toGraphQLQuery } from "./graphQLHelpers.js";

const REQUESTS = {
  index: ({projectId}, outputFields = `id`) => {
    return `query {
      users(projectId: "${projectId}"){
        ${outputFields}
      }
    }`;
  },
  update: ({ id, officeId, role }, outputFields = `id`) => {
    const query = {
      id,
      ...(officeId && { officeId }),
      ...(role && { role }),
    };
    return `mutation {
      updateUser(user: ${toGraphQLQuery(query)}){
        ${outputFields}
      }
    }`;
  },
  get: (outputFields = `id`) => {
    return `query {
      user{
        ${outputFields}
      }
    }`;
  },
};

const initialState = {
  all: [],
};

export const usersApi = {
  index: async (payload, outputFields, next) => {
    //
    const result = await apiClient.req(REQUESTS.index(payload, outputFields));
    //
    next(result.data.data.users);
  },
  update: async (payload, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.update(payload, outputFields));
    next(result.data.data.updateUser);
  },
  get: async (outputFields, next) => {
    const result = await apiClient.req(REQUESTS.get(outputFields));
    next(result.data.data.user);
  },
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUsers: (state, { payload: { users } }) => {
      return {
        ...state,
        all: users.slice().sort((a, b) => a.email.localeCompare(b.email)), // sort by email
      };
    },
    updateUser: (state, { payload: { user } }) => {
      return {
        ...state,
        all: state.all.map((u) => {
          if (u.id !== user.id) {
            return u;
          } else {
            return user;
          }
        }),
      };
    }, 
  },
});

export const { setUsers, updateUser} = usersSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectGetUser = (state) => {
  return (user_id) => {
    const cands = state.users.all.filter((el) => el.id === user_id);
    if (cands.length === 0) {
      return { name: "Unknown" };
    } else {
      return cands[0];
    }
  };
};
export const selectUsers = (state) => {
  return state.users.all;
};

export default usersSlice.reducer;
